/**
 * @generated SignedSource<<4f2775a750ee9ec887219aa8aa079fa9>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "connectionsToDeleteEdgeFrom"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "model",
            "variableName": "model"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userIds",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "ServiceUsersPage_removeUsersToServiceMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "RemoveUsersFromServicePayload",
                    "kind": "LinkedField",
                    "name": "removeUsersFromService",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/)
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "ServiceUsersPage_removeUsersToServiceMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "RemoveUsersFromServicePayload",
                    "kind": "LinkedField",
                    "name": "removeUsersFromService",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "filters": null,
                            "handle": "deleteEdge",
                            "key": "",
                            "kind": "ScalarHandle",
                            "name": "userIds",
                            "handleArgs": [
                                {
                                    "kind": "Variable",
                                    "name": "connections",
                                    "variableName": "connectionsToDeleteEdgeFrom"
                                }
                            ]
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "44e1dc4349dfa4f9cfce8baf856079b6",
            "id": null,
            "metadata": {},
            "name": "ServiceUsersPage_removeUsersToServiceMutation",
            "operationKind": "mutation",
            "text": "mutation ServiceUsersPage_removeUsersToServiceMutation(\n  $model: RemoveUsersFromServiceInput!\n) {\n  removeUsersFromService(model: $model) {\n    userIds\n  }\n}\n"
        }
    };
})();
node.hash = "47c94a6efc3d933963dac7f61ac5731b";
export default node;
